const formatEnumLabel = (value) =>
  String(value || "")
    .split("_")
    .filter(Boolean)
    .map((segment) => {
      if (segment.toLowerCase() === "odm") return "ODM";
      return segment.charAt(0).toUpperCase() + segment.slice(1);
    })
    .join(" ");

const createEnumOptions = (enumObject, customLabels = {}) =>
  Object.values(enumObject).map((value) => ({
    value,
    label: customLabels[value] || formatEnumLabel(value),
  }));

const createEnumLabelResolver = (options = []) => {
  const labelLookup = new Map(
    options.map((option) => [String(option?.value || ""), String(option?.label || "")])
  );

  return (value) => labelLookup.get(String(value || "")) || String(value || "");
};

export const VariableTypeEnum = Object.freeze({
  PerKm: "per_km",
  PerLtr: "per_ltr",
});

export const TripDataTypeEnum = Object.freeze({
  LoadQuantity: "load_quantity",
  FixedDistance: "fixed_distance",
  OdometerDistance: "odometer_distance",
  LocationRate: "location_rate",
  FuelPrice: "fuel_price",
  FuelQuantity: "fuel_quantity",
  ShortQuantity: "shortage_qty",
});

export const StorageTripDataTypeEnum = Object.freeze({
  LocationRate: "location_rate",
  ProductLoadPrice: "product_load_price",
  ProductUnLoadPrice: "product_unload_price",
  ShortageQty: "shortage_qty",
});

export const FixedTypeEnum = Object.freeze({
  Parking: "parking",
  DriverWages: "driver_wages",
  Toll: "toll",
  Loading: "loading",
  Unloading: "unloading",
});

const pricingTemplateEnumLabels = {
  [TripDataTypeEnum.OdometerDistance]: "Odometer Distance",
};

export const variableTypeOptions = createEnumOptions(VariableTypeEnum);
export const fixedTypeOptions = createEnumOptions(
  FixedTypeEnum,
  pricingTemplateEnumLabels
);
export const tripDataTypeOptions = createEnumOptions(
  TripDataTypeEnum,
  pricingTemplateEnumLabels
);
export const storageTripDataTypeOptions = createEnumOptions(
  StorageTripDataTypeEnum,
  pricingTemplateEnumLabels
);

export const getVariableTypeLabel = createEnumLabelResolver(variableTypeOptions);
export const getFixedTypeLabel = createEnumLabelResolver(fixedTypeOptions);
export const getTripDataTypeLabel = createEnumLabelResolver([
  ...tripDataTypeOptions,
  ...storageTripDataTypeOptions,
]);
export const getStorageTripDataTypeLabel = createEnumLabelResolver(storageTripDataTypeOptions);

export const componentTypeOptions = [
  { label: "Per KM", value: "per_km" },
  { label: "Per Trip", value: "per_trip" },
  { label: "Per Ton", value: "per_ton" },
  { label: "Fuel Adjustment", value: "fuel_adjustment" },
  { label: "Parking (Fixed)", value: "parking" },
  { label: "Driver Wages (Fixed)", value: "driver_wages" },
  { label: "Toll (Fixed)", value: "toll" },
  { label: "Loading (Fixed)", value: "loading" },
  { label: "Unloading (Fixed)", value: "unloading" },
];
